exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon__icon__1DH8U{font-family:fontello-vod;font-style:normal;font-weight:400;speak:none;text-decoration:inherit;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon__rounded-icon__37CwH{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;border:1px solid #000;border-radius:50%}", ""]);

// exports
exports.locals = {
	"icon": "icon__icon__1DH8U",
	"rounded-icon": "icon__rounded-icon__37CwH",
	"roundedIcon": "icon__rounded-icon__37CwH"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/shared/components/icon/icon.styl
// module id = 910
// module chunks = 15 16 17 18 19